import { InjectionToken } from '@angular/core';
import { EnvironmentUrlsConfig } from './environment-urls-config.interface';

export const ENVIRONMENT_URLS_CONFIG_TOKEN = new InjectionToken<EnvironmentUrlsConfig>('EnvUrlsConfig');
